export const menuSuperUsuario = [
    {
        path: '/',
        icon: 'home',
        text: 'Início',
        authRequired: true,
        hide: ['usuarioLite']
    },
    {
        path: '/upload-titulos',
        icon: 'cloud_upload',
        text: 'Upload Títulos',
        authRequired: true,
        hide: ['usuarioLite']
    },
    {
        path: '/consulta-titulos',
        icon: 'fas fa-search',
        text: 'Consulta de Títulos',
        authRequired: true
    },
    {
        path: '/download-instrumentos',
        icon: 'mdi-download',
        text: 'Baixar Instrumentos',
        authRequired: true
    },
    {
        path: '/alteracoes-em-lote',
        icon: 'mdi-file-sync-outline',
        text: 'Alterações em Lote',
        authRequired: true,
        hide: ['usuarioLite', 'usuarioBasic'],
        childs: [
            {
                path: '/anuencia-em-massa',
                icon: '',
                text: 'Anuência',
                authRequired: true
            },
            {
                path: '/agrupador-em-massa',
                icon: '',
                text: 'Agrupador',
                authRequired: true
            },
            {
                path: '/upload-em-massa',
                icon: '',
                text: 'Upload Arquivo Protesto',
                authRequired: true,
                hide: ['usuarioAdmin notSuper']
            }
        ]
    },
    {
        path: '/relatorios',
        icon: 'assignment',
        text: 'Relatórios',
        authRequired: true,
        childs: [
            {
                path: '/relatorios-mensageria',
                icon: '',
                text: 'Mensageria',
                authRequired: true
            },
            // {
            //     path: '/exceldetalhado',
            //     icon: '',
            //     text: 'Detalhado Títulos',
            //     authRequired: true
            // },
            {
                path: '/financeiro/repasse',
                icon: '',
                text: 'Repasses e Taxas',
                authRequired: true,
                hide: ['usuarioLite']
            },
            {
                path: '/relatorios-faturamento',
                icon: '',
                text: 'Relatorio Faturamento',
                authRequired: true,
                hide: ['usuarioLite', 'usuarioBasic']
            }
        ]
    },
    {
        path: '/listar-usuarios',
        icon: 'people',
        text: 'Listar Usuários',
        authRequired: true,
        hide: ['usuarioLite', 'usuarioBasic']
    },
    {
        path: '/listar-apresentantes',
        icon: 'people',
        text: 'Listar Apresentantes',
        authRequired: true,
        hide: ['usuarioLite', 'usuarioBasic', 'usuarioAdmin notSuper']
    },
    {
        path: '/listar-agrupadores',
        icon: 'mdi-account-group',
        text: 'Listar Agrupadores',
        authRequired: true,
        hide: ['usuarioLite', 'usuarioBasic']
    },
    {
        path: '/gerenciamento-login-social',
        icon: 'mdi-account-group',
        text: 'Gerenciamento de Login Social',
        authRequired: true,
        hide: ['usuarioLite', 'usuarioBasic', 'usuarioAdmin notSuper']
    },
    {
        path: '/mapa-de-status',
        icon: 'map',
        text: 'Mapa de Títulos',
        authRequired: true,
        hide: ['usuarioLite']
    },
    {
        path: '/manuais',
        icon: 'cloud_download',
        text: 'Manuais',
        authRequired: true,
        hide: ['usuarioLite'],
        childs: [
            {
                path: '/fluxo-de-protesto',
                icon: '',
                text: 'Fluxo de Protesto',
                authRequired: true
            },
            {
                path: '/manual-do-usuario',
                icon: '',
                text: 'Manual do usuário',
                authRequired: true
            },
            {
                path: '/manual-do-protesto',
                icon: '',
                text: 'Manual do protesto',
                authRequired: true
            },
            {
                path: '/manual-de-upload',
                icon: '',
                text: 'Manual de Upload',
                authRequired: true
            },
            {
                path: '/documentacao-api',
                icon: '',
                text: 'Documentação de API',
                authRequired: true
            }
        ]
    },
    {
        path: '/faq',
        icon: 'info',
        text: 'Dúvidas Frequentes',
        authRequired: true,
        hide: ['usuarioLite']
    },
    {
        path: '/sobre',
        icon: 'info',
        text: 'Sobre',
        authRequired: true,
        hide: ['usuarioLite']
    }
];

export default menuSuperUsuario;
